module.exports = __webpack_public_path__ + "static/img/25e.add7ea3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/25e.jpg
// module id = eeYv
// module chunks = 0